import { NavItemDef } from '../navItems';

export const POLICY_NAV_ITEMS: NavItemDef[] = [
  // Policy Manuals section
  {
    key: 'policy.divider.policyManuals',
    label: 'common.navItems.policy.dividers.policyManuals',
    divider: true,
    appPermissions: ['listDraftManuals', 'listIssuedManuals', 'listArchivedManuals'],
  },
  {
    key: 'policy.draft-manuals',
    label: 'common.navItems.policy.draftManuals',
    subtitle: 'common.navItems.policy.subtitles.draftManuals',
    path: 'draft-manuals',
    appPermissions: ['listDraftManuals'],
  },
  {
    key: 'policy.issued-manuals',
    label: 'common.navItems.policy.issuedManuals',
    subtitle: 'common.navItems.policy.subtitles.issuedManuals',
    path: 'issued-manuals',
    appPermissions: ['listIssuedManuals'],
  },
  {
    key: 'policy.archived-manuals',
    label: 'common.navItems.policy.manualHistory',
    subtitle: 'common.navItems.policy.subtitles.manualHistory',
    path: 'archived-manuals',
    appPermissions: ['listArchivedManuals'],
  },
  // Daily Training Bulletins section
  {
    key: 'policy.divider.dtbs',
    label: 'common.navItems.policy.dividers.dtbs',
    divider: true,
    permissions: ['listDtbPackages', 'distributeDtbPackage', 'assignDtbPackageToGroup', 'getDtbLibraryList'],
  },
  {
    key: 'policy.dtb.packages',
    label: 'common.navItems.policy.dtbPackages',
    subtitle: 'common.navItems.policy.subtitles.dtbPackages',
    href: '/admin/dtbs/packages',
    permissions: ['listDtbPackages'],
  },
  {
    key: 'dtb.distribution',
    label: 'common.navItems.policy.dtbDistribution',
    subtitle: 'common.navItems.policy.subtitles.dtbDistribution',
    href: '/admin/dtbs/distribution',
    permissions: ['distributeDtbPackage'],
  },
  {
    key: 'policy.dtb.assignment',
    label: 'common.navItems.policy.dtbAssignment',
    subtitle: 'common.navItems.policy.subtitles.dtbAssignment',
    href: '/admin/dtbs/assignments',
    permissions: ['assignDtbPackageToGroup'],
  },
  {
    key: 'policy.dtb.library',
    label: 'common.navItems.policy.dtbLibrary',
    subtitle: 'common.navItems.policy.subtitles.dtbLibrary',
    href: '/admin/dtbs/library',
    permissions: ['getDtbLibraryList'],
  },
];
